export function Testimonial() {
  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6">
      <div className="max-w-3xl mx-auto text-center">
        <div className="mb-6 sm:mb-8">
          <svg
            className="w-10 h-10 sm:w-12 sm:h-12 text-[#71ED7F]/30 mx-auto"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
          </svg>
        </div>

        <blockquote className="text-xl sm:text-2xl md:text-3xl font-medium leading-relaxed mb-6 sm:mb-8 text-white">
          "The interface is gorgeous and my members actually use it. That never happened with our old
          system."
        </blockquote>

        <div className="flex items-center justify-center gap-3 sm:gap-4">
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-br from-[#71ED7F] to-[#5BC969] flex items-center justify-center text-[#001716] font-bold text-sm sm:text-base">
            C
          </div>
          <div className="text-left">
            <p className="font-semibold text-white text-sm sm:text-base">Casey</p>
            <p className="text-white/40 text-xs sm:text-sm">BLVD Golf Club</p>
          </div>
        </div>
      </div>
    </section>
  )
}
